import React from "react";
import AssetGrid from "./AssetGrid";

interface LightingTabProps {
  assets: BrandAsset[];
  projectId: string;
  onUpload: (file: File) => Promise<void>;
  onDelete: (assetId: string) => void;
  onUpdate: (assetId: string, updates: FormData) => void;
}

const LightingTab: React.FC<LightingTabProps> = ({ assets, projectId, onUpload, onDelete, onUpdate }) => {
  const lightingRefs = assets.filter((a) => a.type === "lighting_ref");

  return (
    <AssetGrid
      assets={lightingRefs}
      assetType="lighting_ref"
      onUpload={onUpload}
      onDelete={onDelete}
      onUpdate={onUpdate}
      emptyMessage="No lighting references yet. Upload images whose lighting mood you want generations to match."
    />
  );
};

export default LightingTab;
